import React from "react";
import {
  APIProvider,
  Map,
  Marker,
  useMap
} from "@vis.gl/react-google-maps";
import { Box, CircularProgress, Typography } from "@mui/material";
import * as ETVConstants from "../ETVConstants";
import SearchBox from "./Searchbox";

function MapController({ lat, lng }) {
  const map = useMap();

  React.useEffect(() => {
    if (map && lat && lng) {
      map.panTo({ lat, lng });
    }
  }, [lat, lng, map]);

  return null;
}


class LocationMap extends React.Component {
  state = {
    initial_lat: this.props.lat || 1.283964,
    initial_lgt: this.props.lgt || 103.851296,
    locationLoading: false
  };

  componentDidMount() {
    if (!this.props.lat || this.props.lat === 0) {
      this.setState({ locationLoading: true });
      this.getLocation();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.lat !== prevProps.lat ||
      this.props.lgt !== prevProps.lgt
    ) {
      const lat = this.props.lat || 1.283964;
      const lgt = this.props.lgt || 103.851296;
      this.setState({ initial_lat: lat, initial_lgt: lgt });
    }
  }

  getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setState({
            initial_lat: position.coords.latitude,
            initial_lgt: position.coords.longitude,
            locationLoading: false
          });
        },
        (error) => {
          this.setState({
            error: error.message,
            locationLoading: false
          });
        }
      );
    } else {
      this.setState({
        error: "Geolocation is not supported by this browser."
      });
    }
  };

  onMapClicked = (ev) => {
    const latLng = ev.detail?.latLng;
    if (latLng) {
      const latitude = latLng.lat;
      const longitude = latLng.lng;
      this.props.setLocationGPS(latitude, longitude, "");
      this.setState({ initial_lat: latitude, initial_lgt: longitude });
    }
  };

  handlePlaceSelected = ({lat, lng, name}) => {
    this.setState({ initial_lat: lat, initial_lgt: lng });
    if (this.props.setLocationGPS) {
      this.props.setLocationGPS(lat, lng, name || "");
    }
  };

  loadingSpinner() {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography variant="h6" gutterBottom>
          {ETVConstants.trans("loading_location")}
        </Typography>
        <CircularProgress style={{ width: 100, height: 100 }} />
      </Box>
    );
  }

  render() {
    if (
      this.state.locationLoading ||
      !this.state.initial_lat ||
      !this.state.initial_lgt
    )
      return this.loadingSpinner();

    return (
      <APIProvider
        apiKey="AIzaSyBZR-UP1mmXMQGfNNuBxnfLEMREN8QJf2A"
        libraries={["places"]}
      >
        <div style={{ position: "relative", width: "100%", height: "800px" }}>
          <SearchBox onPlaceSelected={this.handlePlaceSelected} />
          <Map
            onClick={this.onMapClicked}
            style={{ width: "100%", height: "100%" }}
            defaultZoom={12}
            gestureHandling="greedy"
            disableDefaultUI={true}
            defaultCenter={{
              lat: this.state.initial_lat,
              lng: this.state.initial_lgt
            }}
          >
            <MapController
              lat={this.state.initial_lat}
              lng={this.state.initial_lgt}
            />
            <Marker
              position={{
                lat: this.state.initial_lat,
                lng: this.state.initial_lgt
              }}
            />
          </Map>
        </div>
      </APIProvider>
    );
  }
}

export default LocationMap;
